import { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getAPIPath } from '../browser-extension/utils/api-path-utils';
import { isExtension } from '../browser-extension/utils/extension-utils';
import { apiClient } from '@plerionhq/design-system';

// Custom adapter for handling API requests
const extensionAdapter = async (
  config: InternalAxiosRequestConfig,
): Promise<AxiosResponse> => {
  // If we're in a Chrome extension, proxy the request through the background script
  try {
    const apiPath = await getAPIPath();

    const serializableConfig = {
      url: config.url,
      method: config.method,
      data: config.data,
      headers: config.headers,
      params: config.params,
      timeout: config.timeout,
    };

    if (!apiPath) {
      return Promise.reject(new Error('No API path found'));
    }

    // Send the request to the background script
    const response = await chrome.runtime.sendMessage({
      type: 'API_REQUEST',
      config: { ...serializableConfig, baseURL: `https://${apiPath}` },
    });

    // Return the response in the format axios expects
    return {
      data: response.data,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      config: { ...config, baseURL: `https://${apiPath}` },
    };
  } catch (error) {
    // Handle errors from the background script
    return Promise.reject(error);
  }
};

apiClient.defaults.timeout = 100000;
if (isExtension) {
  apiClient.defaults.adapter = extensionAdapter;
}

export default apiClient;
